exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".liststyle[data-v-6458ddba]{height:calc(50vh - 170px) !important}", ""]);

// exports
